import { useEffect, useRef, useState } from 'react'
import { fetchBlobFromUrl } from './upload'

export function useResolvedUrl(rawUrl) {
  const [resolvedUrl, setResolvedUrl] = useState(rawUrl || '')
  const lastObjectUrlRef = useRef('')

  useEffect(() => {
    let cancelled = false

    const cleanup = () => {
      if (lastObjectUrlRef.current) {
        try {
          URL.revokeObjectURL(lastObjectUrlRef.current)
        } catch {}
        lastObjectUrlRef.current = ''
      }
    }

    const run = async () => {
      cleanup()
      const u = String(rawUrl || '')
      if (!u) {
        setResolvedUrl('')
        return
      }
      if (!u.startsWith('idb:')) {
        setResolvedUrl(u)
        return
      }
      try {
        const blob = await fetchBlobFromUrl(u)
        if (cancelled) return
        if (!blob) {
          setResolvedUrl('')
          return
        }
        const objUrl = URL.createObjectURL(blob)
        lastObjectUrlRef.current = objUrl
        setResolvedUrl(objUrl)
      } catch {
        if (!cancelled) setResolvedUrl('')
      }
    }

    run()

    return () => {
      cancelled = true
      cleanup()
    }
  }, [rawUrl])

  return resolvedUrl
}

